module.exports = __webpack_public_path__ + "img/role_specificity.516d27fb.svg";